import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SERVER_API_URL } from '@app/app.constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  constructor(private http: HttpClient) {}

  getTerms(): Observable<any> {
    return this.http.get(SERVER_API_URL + `terms-conditions`);
  }
}
